import Mark from 'mark.js';

export default class Search {
  constructor() {
    // Recherche
    
    this.getQuery();
  }

  getQuery() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const getQuery = urlSearchParams.get('s');
    this.markup(getQuery);
  }

  markup(value) {
    const instance = new Mark('.search-results section.content .search-results .item');
    instance.mark(value);
  }
}